// src/features/audit-monitor/components/AuditOrdersList/BipickingGroup.js
import React from 'react';
import { object, func } from 'prop-types';
import { Divider } from 'antd';
import { get } from 'lodash';
import { Button,HasPermissions } from '../../../../components/common';
import AuditOrderCardContent from './AuditOrderCardContent';
import { BLUE, RED } from '../../../../utils/colors';

const AuditGroupOrdersCard = ({ group, onOrderClick, style }) => {
    const { primaryOrder, secondaryOrder } = group;

    return (<div style={{ gridColumn: 'span 2', ...style }}>
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* Orden A */}
                <AuditOrderCardContent
                    data={primaryOrder}
                    onClickHandler={onOrderClick}
                    bipickingInfo={{
                        isBipicking: true,
                        iconName: 'bipicking-a',
                        iconColor: BLUE,
                        partnerId: get(secondaryOrder, 'id')
                    }}
                />

                <Divider type='vertical' style={{ marginTop: 20, height: 225 }} />

                {/* Orden B */}
                <AuditOrderCardContent
                    data={secondaryOrder}
                    onClickHandler={onOrderClick}
                    bipickingInfo={{
                        isBipicking: true,
                        iconName: 'bipicking-b',
                        iconColor: RED,
                        partnerId: get(primaryOrder, 'id'),
                    }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <HasPermissions to={['audit-monitor:audit-action']}>
                    <Button
                        text='Auditar órdenes'
                        onClick={() => onOrderClick(group)} // Pasar todo el grupo
                        secondary
                        style={{ width: '50%' }}
                    />
                </HasPermissions>
            </div>
        </div>
    </div>);
};

AuditGroupOrdersCard.propTypes = {
    group: object.isRequired,
    onOrderClick: func.isRequired
};

export default AuditGroupOrdersCard;